import React from "react";

export default function(props){
    const {parent, data} = props;
    return (<div>
         <h4 style={{margin:0}}>Campaign</h4>
        <h1 style={{margin:0}}>{data.name}</h1>
    </div>)
}